<template>
    <div class="g-container-box">
        <el-row class="g-header-container">
            <el-col :span="3">
                <div class="g-header-left">熟客控制台</div>
            </el-col>
            <el-col :span="16">
                <nav-head navSel="1"></nav-head>
            </el-col>
            <el-col :span="5">
                <op-head></op-head>
            </el-col>
        </el-row>
        <el-row class="g-view-container">
            <el-col :span="3" class="g-menu-container">
                <sidebar navType="2" defaultSel="4"></sidebar>
            </el-col>
            <el-col :span="21" class="g-center-container">
                <div class="smi_back">
                    <p>
                        <span>累积营收：{{ total }}</span>
                        <span @click="backList">查看明细</span>
                    </p>
                    <p>
                        <span>余额：{{ yeData }}</span>
                        <span @click="tiXian">提现</span>
                    </p>
                </div>
                <el-table :data="listData" style="width: 100%">
                    <el-table-column prop="eventTime" label="时间"></el-table-column>
                    <el-table-column prop="eventName" label="事件"></el-table-column>
                    <el-table-column prop="amount" label="金额"></el-table-column>
                </el-table>
            </el-col>
        </el-row>
    </div>
</template>
  
<script>
var util = require("@/common/util.js");
import { API_YSTJSHJ, API_PINGTTX, API_PINGTYE } from "../../assets/js/api.js";
import sidebar from '../../components/sidebar'
import navHead from "../../components/navHead";
import opHead from "../../components/opHead.vue";
export default {
    components: {
        sidebar,
        navHead,
        opHead
    },
    data() {
        return {
            total: 0,
            listData: '',
            dialog: false,
            name: '',
            wxName: '',
            yeData: 0
        }
    },
    created() {
        this.getListData()
        this.getYuer()
    },
    methods: {
        getListData() {
            let params = {}
            util.getData(API_YSTJSHJ, params, (res) => {
                this.total = res.data.data.total
                this.listData = res.data.data.list
            })
        },
        getYuer() {
            let params = {}
            util.getData(API_PINGTYE, params, (res) => {
                this.yeData = res.data.data
            })
        },
        tiXian(){
            
            // let params = new URLSearchParams();
            // params.append('settledAmount', this.yeData);
            // util.getData(API_PINGTTX, params, (res) => {
            //     this.$message('操作成功')
            //     this.getListData()
            //     this.getYuer()
            // })
        },
        backList(){
            this.$router.push({ path: '/glyYsmx' });
        }
    }
}
</script>
  
<style lang="less">
.smi_back{
    color: #333;
    margin-bottom: 20px;
    display: flex;
    flex-direction: row;
    p{
        margin-right: 30px;
        span:last-child{
            cursor: pointer;
            color: #ea9c0d;
            padding-left: 10px;
        }
    }
}
.g-container-box {
    overflow: hidden;
}

.g-header-left {
    background-color: #5c6be8;
    color: #FFF;
    height: 60px;
    line-height: 60px;
    text-align: center;
}

.g-menu-container {
    height: 800px;
    background-color: #fff;
}
.g-center-container {
    overflow: auto;
    height: 800px;
    background-color: #eff3f6;
    padding: 20px;
}

.nav_search {
    margin-top: 10px;
    margin-bottom: 30px;
}

.order_input1 {
    margin-bottom: 20px;
}</style>


// WEBPACK FOOTER //
// src/pages/glyYstj/index.vue